export type FacilityProfile = {
  name: string;
  logoUrl: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  website: string;
};

export const EMPTY_FACILITY_PROFILE: FacilityProfile = {
  name: '',
  logoUrl: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
  email: '',
  website: '',
};
